module.exports = __webpack_public_path__ + "img/burger.65ff6af1.svg";